/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { api } from "../../config/api";
import { pages } from "../../constants/PagePaths";
import "./myPage.scss";
import AlertContext from "../../contexts/AlertContext";
import DupLoginContext from "../../contexts/DupLoginContext";
import { checkAndProcessExpiredPromotions } from "../../services/promotionService";
import PaymentHistoryModal from "../../components/paymentHistory/PaymentHistoryModal";
import {
  HistoryPoductModel,
  PaymentHistoryModel,
} from "../../models/payment/PaymentHistoryModel";
import CouponBoxModel from "../../models/coupon/CouponBoxModel";
import {
  IamportPayMethod,
  payMethodMapper,
} from "../../models/payment/iamport/ImpModels";
import { ExpiryDateModel } from "../../models/user/UserInfo";
import CountUp from "react-countup";
import {
  UserPermission,
  UserPermissionKorMapper,
} from "../../models/user/UserPermission";
import PaymentHistory from "../../components/paymentHistory/PaymentHistory";
import RegisterCouponModal from "../../components/modal/coupon/RegisterCouponModal";
import CouponList from "../../components/coupon/CouponList";
import CouponListModal from "../../components/modal/coupon/CouponListModal";
import MyPageHeader from "./MyPageHeader";
import { util } from "../../config/util";
import { Cookies } from "../../constants/Cookies";
import SubscriptionDetailModal from "../../components/modal/subscription/SubscriptionDetailModal";

// 다중 패키지 구독 관련 인터페이스
interface SingleSubscriptionInfo {
  productId: number;
  productName: string;
  amount: number;
  isYearly: boolean;
  periodText: string; // "월간" 또는 "연간"
  nextPaymentDate: string;
  startDate: string;
  isActive: boolean;
  billingKey?: string;
  scheduleId?: string;
  // 넷플릭스 방식: 취소 상태
  cancel_requested?: boolean;
  cancel_requested_at?: string | null;
  expiry_date?: string | null;
}

interface SubscriptionInfo {
  isActive: boolean;
  subscriptions: SingleSubscriptionInfo[]; // 다중 패키지 목록
  cardInfo?: {
    cardBrand?: string;
    cardLast4?: string;
  };
}

// 프로모션 관련 인터페이스
interface PromotionInfo {
  has_promotion: boolean;
  promotion_type: string | null;
  remaining_days: number;
  is_expired: boolean;
  promotion?: {
    promotion_id: number;
    promotion_type: string;
    start_date: string;
    end_date: string;
    remaining_days: number;
    is_active: boolean;
  };
  promotion_at_risk?: {  // 🎁 구독 취소 시 손실될 프로모션 정보
    promotion_type: string;
    remaining_days: number;
    end_date: string;
    description: string;
  } | null;
  all_active_promotions?: {  // 🎁 모든 활성 프로모션 정보
    promotion_type: string;
    korean_name: string;
    remaining_days: number;
    end_date: string | null;
    start_date: string | null;
    lost_on_cancel: boolean;
  }[];
}



interface Props {}

export default () => {
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [coupons, setCoupons] = useState<CouponBoxModel[]>([]);
  const [expires, setExpires] = useState<ExpiryDateModel[]>([]);
  const [expireCodes, setExpireCodes] = useState<string[]>([]);
  const [paymentHistory, setPaymentHistory] = useState<PaymentHistoryModel[]>([]);
  const [historyProducts, setHistoryProducts] = useState<HistoryPoductModel[][]>([]);
  
  // 다중 패키지 구독 관리 관련 state
  const [subscriptionInfo, setSubscriptionInfo] = useState<SubscriptionInfo>({
    isActive: false,
    subscriptions: []
  });
  
  // 구독 상세보기 모달 관련 state
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedSubscription, setSelectedSubscription] = useState<SingleSubscriptionInfo | null>(null);
  
  // 프로모션 관련 state
  const [promotionInfo, setPromotionInfo] = useState<PromotionInfo>({
    has_promotion: false,
    promotion_type: null,
    remaining_days: 0,
    is_expired: false
  });
  
  const alert = useContext(AlertContext);
  const dupLogin = useContext(DupLoginContext);
  const history = useHistory();
  const [selectedExpireIndex, setSelectedExpireIndex] = useState(0);


  const clearUserInfo = () => {
    try {
      api.logout();
      history.push(pages.index);
    } catch (err) {}
    util.deleteCookie(Cookies.authKey);
    window.location.reload();
  };

  useEffect(() => {
    new Promise(async () => {
      try {
        const res = await api.getMyInfo();
        setUserName(res.data.last_name);
        setEmail(res.data.email);
        setPhone(res.data.phone);
        setAddress(res.data.addr);

        const expires = res.data?.expiry_dates?.map((expireModel) => {
          const date = expireModel.expiry_date
            ? new Date(expireModel.expiry_date)
            : undefined;
          return {
            expiry_date: date,
            name: expireModel.name,
            permission_image: expireModel.permission_image,
            permission_title: expireModel.permission_title,
          };
        });
        setExpireCodes(
          res.data?.expiry_dates?.map((expireModel) =>
            expireModel.name.toLocaleLowerCase()
          )
        );

        setExpires(expires);
      } catch (error) {
        console.error(error);
        history.replace(pages.index);
      }

      try {
        const payHistory = await api.getPaymentHistoryAsync(0, 5);
        const { products, paymentHistories } = getHistories(payHistory);
        setHistoryProducts(products);
        setPaymentHistory(paymentHistories);
        const coupons = await getCoupons(0, 5);
        setCoupons(coupons);
      } catch (error) {
        console.error(error);
      }

      // 구독 정보 로드 추가
      try {
        await loadSubscriptionInfo();
        
        // 프로모션 만료 체크 및 처리
        console.log('[MyPage] 프로모션 만료 체크 시작');
        const promotionStatus = await checkAndProcessExpiredPromotions();
        console.log('[MyPage] 프로모션 만료 체크 완료:', promotionStatus);
        
      } catch (error) {
        console.error("구독 정보 로드 실패:", error);
      }

    });
  }, []);

  // 프로모션 상태 변경 모니터링
  useEffect(() => {
    console.log('[MyPage] promotionInfo 상태 변경:', promotionInfo);
    if (promotionInfo.all_active_promotions && promotionInfo.all_active_promotions.length > 0) {
      console.log('[MyPage] 현재 활성 프로모션 개수:', promotionInfo.all_active_promotions.length);
      promotionInfo.all_active_promotions.forEach((promo, idx) => {
        console.log(`[MyPage] 프로모션 ${idx + 1}:`, promo);
      });
    } else {
      console.log('[MyPage] 활성 프로모션이 없거나 빈 배열');
    }
  }, [promotionInfo]);


  const getCoupons = async (offset?: number, limit?: number) => {
    const couponsRes = await api.getCouponHistoryAsync(offset, limit);
    const tempCoupons = couponsRes.data.coupons.map(
      (coupon: any): CouponBoxModel => {
        return {
          name: coupon.name,
          expiryDate: coupon.expiry_date,
          key: coupon.key,
        };
      }
    );
    return tempCoupons;
  };

  const handleCouponMore = async () => {
    const coupons = await getCoupons();
    alert.showContentModal(
      <CouponListModal
        coupons={coupons}
        onConfirm={() => alert.closeAlert()}
      />,
      {
        width: "1200px",
      }
    );
  };

  const handlePayHistoryMore = async () => {
    const payHistory = await api.getPaymentHistoryAsync();
    const { products, paymentHistories } = getHistories(payHistory);
    alert.showContentModal(
      <PaymentHistoryModal
        histories={paymentHistories}
        handleClickVbankInfo={handleClickVbankInfo}
        historyProducts={products}
        onConfirm={() => alert.closeAlert()}
      />,
      {
        width: "1200px",
      }
    );
  };

  const handleClickVbankInfo = (index: number) => {
    const vbankDate = +(paymentHistory?.[index]?.vbankDate ?? "0");
    const date = new Date(vbankDate * 1000);
    alert.showAlert(
      `입금 기한 : ${date.format("yyyy.MM.dd HH:mm")}까지\n입금 계좌 : ${
        paymentHistory?.[index]?.vbankName
      } ${paymentHistory?.[index]?.vbankNum}\n계좌명 : ${
        paymentHistory?.[index]?.vbankHolder
      }`
    );
  };

  const getRemainDays = (expire: ExpiryDateModel | undefined) => {
    const currentTime = new Date().getTime();
    const expireDate = expire?.expiry_date?.getTime() ?? currentTime;
    return Math.max(
      Math.ceil((expireDate - currentTime) / (1000 * 3600 * 24)) +
        (expireDate - currentTime > 0 ? 1 : 0),
      0
    );
  };

  // 구독 만료 여부 체크 (cancel_requested + next_payment_date/expiry_date 조합)
  const isSubscriptionExpired = (sub: SingleSubscriptionInfo): boolean => {
    if (!sub.cancel_requested) return false;
    // 취소 예정 구독의 만료일은 expiry_date 또는 nextPaymentDate
    const expiryDate = sub.expiry_date || sub.nextPaymentDate;
    if (!expiryDate) return false;
    return new Date(expiryDate) < new Date();
  };

  const getHistories = (payHistory: any) => {
    const products = payHistory.data.products.map((products: any) => {
      return products.map((prod: any) => {
        return {
          id: prod.id,
          paymentHistoryId: prod.payment_history_id,
          productId: prod.product_id,
          productPrice: prod.product_price,
          productName: prod.product_name,
          startDate: new Date(prod.start_date),
          expireDate: new Date(prod.expire_date),
          productDiscount: prod.product_discount,
        };
      });
    });
    const paymentHistories = payHistory.data.histories.map(
      (historyItem: any): PaymentHistoryModel => {
        const payMethod =
          Object.values(IamportPayMethod).find(
            (value) => value === historyItem.pay_method
          ) || IamportPayMethod.card;
        // milliseconds to seconds. cause its not unix Epoch value
        const paidAt = new Date(historyItem.paid_at * 1000)
          .format("yyyy.MM.dd")
          .trim();
        const expireDate = new Date(historyItem.expire_date)
          .format("yyyy.MM.dd")
          .trim();
        const startDate = new Date(historyItem.start_date)
          .format("yyyy.MM.dd")
          .trim();
        const status =
          historyItem.paid_at == undefined || historyItem.paid_at === 0
            ? new Date(historyItem.vbank_date).getTime() < Date.now()
              ? "만료"
              : "대기"
            : historyItem.canceled_time
            ? "취소"
            : "완료";
        return {
          id: historyItem.id,
          amount: historyItem.paid_amount?.toLocaleString() + "원",
          payMethod: payMethodMapper[payMethod],
          prodName: historyItem.product_name
            ? `[${historyItem.product_name}]`
            : "",
          receiptUrl: historyItem.receipt_url,
          payRegistDate: paidAt,
          payRequestDate: new Date(historyItem.create_time).format(
            "yyyy.MM.dd"
          ),
          payTerm: startDate && expireDate ? `${startDate}~${expireDate}` : "",
          status,
          vbankHolder: historyItem.vbank_holder,
          vbankName: historyItem.vbank_name,
          vbankNum: historyItem.vbank_num,
          vbankDate: historyItem.vbank_date,
        };
      }
    );
    return { products, paymentHistories };
  };

  // 구독 관리 함수들 추가
  const loadSubscriptionInfo = async () => {
    try {
      // 실제 카드 정보 가져오기 (기존 결제수단 API 사용)
      const billingResponse = await dupLogin.checkDupLogin(() =>
        api.getSubscriptionBillingAsync()
      );

      let cardInfo = undefined;
      if (billingResponse?.data?.code === 1 && billingResponse.data.data?.billing_info) {
        const billing = billingResponse.data.data.billing_info;
        cardInfo = {
          cardBrand: billing.card_brand || billing.card_name || '카드',
          cardLast4: billing.card_last4
        };
      } else if (billingResponse?.data?.code === 1 && billingResponse.data.billing_info) {
        // 기존 구조도 지원
        const billing = billingResponse.data.billing_info;
        cardInfo = {
          cardBrand: billing.card_brand || billing.card_name || '카드',
          cardLast4: billing.card_last4
        };
      }

      // 구독 상태 조회 API 사용
      const response = await dupLogin.checkDupLogin(() =>
        api.getUserSubscriptionStatusAsync()
      );

      // 프로모션 상태 별도 조회
      const promotionResponse = await dupLogin.checkDupLogin(() =>
        api.getPromotionStatusAsync()
      );
      console.log('[MyPage] 프로모션 API 응답:', promotionResponse);

      if (response?.status === 200 && response.data?.code === 1) {
        const subscriptionData = response.data;
        console.log('[MyPage] 구독 데이터 전체:', subscriptionData);
        console.log('[MyPage] 응답 객체의 모든 키:', Object.keys(subscriptionData));
        console.log('[MyPage] 프로모션 관련 가능한 필드들:');
        Object.keys(subscriptionData).forEach(key => {
          if (key.toLowerCase().includes('promo')) {
            console.log(`[MyPage] ${key}:`, subscriptionData[key]);
          }
        });
        console.log('[MyPage] all_active_promotions:', subscriptionData.all_active_promotions);
        console.log('[MyPage] promotion_at_risk:', subscriptionData.promotion_at_risk);
        console.log('[MyPage] 구독 API의 모든 프로모션 관련 키들:');
        Object.keys(subscriptionData).forEach(key => {
          if (key.toLowerCase().includes('promo') || key.toLowerCase().includes('trial') || key.toLowerCase().includes('subscription')) {
            console.log(`[MyPage] 구독 API - ${key}:`, subscriptionData[key]);
          }
        });
        
        if (subscriptionData.active_packages && subscriptionData.active_packages.length > 0) {
        
          // 먼저 프로모션 정보를 확인해서 실제 결제 시작일을 계산
          let actualBillingStartDate: string | null = null;
          
          // 프로모션 API 응답이 있는 경우 실제 결제일 계산
          if (promotionResponse?.status === 200 && promotionResponse.data?.code === 1) {
            const tempPromotionData = promotionResponse.data.data;
            const tempPromotionHistory = tempPromotionData?.promotion_history || [];
            
            if (tempPromotionHistory.length > 0) {
              const latestHistory = tempPromotionHistory[0];
              const details = latestHistory?.details;
              
              // 복합 프로모션인 경우 전체 프로모션 종료일이 실제 결제 시작일
              if (details?.is_compound_promotion && details?.end_date) {
                actualBillingStartDate = details.end_date.split('T')[0];
                console.log('[MyPage] 복합 프로모션 전체 종료 시간:', details.end_date);
                console.log('[MyPage] 복합 프로모션 종료일 = 실제 결제 시작일:', actualBillingStartDate);
                
                // 구독 시작 시간 확인 (원본 등록 시간)
                if (details.trial_start_date) {
                  console.log('[MyPage] 원본 구독 등록 시간:', details.trial_start_date);
                  const originalTime = details.trial_start_date.split('T')[1]; // 시간 부분 추출
                  console.log('[MyPage] 원본 등록 시간 (시:분:초):', originalTime);
                  console.log('[MyPage] 예상 정확한 결제 시간:', `${actualBillingStartDate} ${originalTime}`);
                }
              }
              // 단일 프로모션인 경우 현재 프로모션 종료일이 실제 결제 시작일  
              else if (tempPromotionData?.current_promotion?.end_date) {
                actualBillingStartDate = tempPromotionData.current_promotion.end_date.split('T')[0];
                console.log('[MyPage] 단일 프로모션 종료 시간:', tempPromotionData.current_promotion.end_date);
                console.log('[MyPage] 단일 프로모션 종료일 = 실제 결제 시작일:', actualBillingStartDate);
                
                // 구독 시작 시간 확인
                if (tempPromotionData.current_promotion.start_date) {
                  console.log('[MyPage] 원본 구독 등록 시간:', tempPromotionData.current_promotion.start_date);
                  const originalTime = tempPromotionData.current_promotion.start_date.split('T')[1];
                  console.log('[MyPage] 원본 등록 시간 (시:분:초):', originalTime);
                  console.log('[MyPage] 예상 정확한 결제 시간:', `${actualBillingStartDate} ${originalTime}`);
                }
              }
              
              // 실제 결제 시작일이 있으면 다음 결제일도 계산 (패키지별 결제 주기는 나중에 적용)
              if (actualBillingStartDate) {
                console.log('[MyPage] 실제 결제 시작일 확정:', actualBillingStartDate);
              }
            }
          }
        
          // 다중 패키지 구독 정보 처리
          const subscriptions: SingleSubscriptionInfo[] = subscriptionData.active_packages.map((pkg: any) => {
            // 프로모션이 있는 경우 실제 결제일을 사용, 없으면 API 값 사용
            let finalStartDate = actualBillingStartDate || 
                               (pkg.subscription_start_date ? pkg.subscription_start_date.split('T')[0] : 
                                pkg.last_payment_date ? pkg.last_payment_date.split('T')[0] : 
                                subscriptionData.subscription_info?.subscription_start_date?.split('T')[0] || '');
            
            let finalNextPaymentDate: string = '';
            
            // 프로모션이 있고 실제 결제 시작일이 있는 경우 다음 결제일 계산
            if (actualBillingStartDate) {
              const billingStart = new Date(actualBillingStartDate);
              const nextPayment = new Date(billingStart);
              
              // 패키지별 결제 주기에 따라 다음 결제일 계산
              if (pkg.is_yearly) {
                nextPayment.setFullYear(nextPayment.getFullYear() + 1);
              } else {
                nextPayment.setMonth(nextPayment.getMonth() + 1);
              }
              
              finalNextPaymentDate = nextPayment.toISOString().split('T')[0];
            } else {
              // 프로모션이 없는 경우 API 값 사용
              finalNextPaymentDate = pkg.next_payment_date || pkg.next_payment || '';
            }
                                     
            console.log(`[MyPage] 패키지 ${pkg.product_name}:`);
            console.log(`[MyPage] - 원본 시작일: ${pkg.subscription_start_date}`);
            console.log(`[MyPage] - 실제 구독 시작일: ${finalStartDate}`);
            console.log(`[MyPage] - 원본 다음 결제일: ${pkg.next_payment_date}`);
            console.log(`[MyPage] - 계산된 다음 결제일: ${finalNextPaymentDate}`);
            console.log(`[MyPage] - 결제 주기: ${pkg.is_yearly ? '연간' : '월간'}`);
            
            return {
              productId: pkg.product_id,
              productName: pkg.product_name,
              amount: Number(pkg.monthly_amount) || 0,
              isYearly: pkg.is_yearly,
              periodText: pkg.is_yearly ? '연간' : '월간',
              nextPaymentDate: finalNextPaymentDate,
              startDate: finalStartDate,
              isActive: subscriptionData.subscription_active || false,
              billingKey: subscriptionData.subscription_info?.card_info?.card_last4 || '',
              scheduleId: pkg.schedule_id,
              // 넷플릭스 방식: 취소 상태
              cancel_requested: pkg.cancel_requested || false,
              cancel_requested_at: pkg.cancel_requested_at || null,
              expiry_date: pkg.expiry_date || null
            };
          });

          // 카드 정보는 새로운 구독 API 응답에서 가져오기
          const apiCardInfo = subscriptionData.subscription_info?.card_info ? {
            cardBrand: subscriptionData.subscription_info.card_info.card_brand || '카드',
            cardLast4: subscriptionData.subscription_info.card_info.card_last4 || '1234'
          } : cardInfo;

          setSubscriptionInfo({
            isActive: subscriptionData.subscription_active || false,
            subscriptions: subscriptions,
            cardInfo: apiCardInfo
          });
          
        } else {
          console.log('[MyPage] 구독 패키지 없음, 프로모션만 처리');
          // 구독 패키지가 없거나 비어있는 경우
          setSubscriptionInfo({ 
            isActive: subscriptionData.subscription_active || false, 
            subscriptions: [] 
          });
        }

        // 프로모션 정보는 별도 API에서 처리
        if (promotionResponse?.status === 200 && promotionResponse.data?.code === 1) {
          const promotionData = promotionResponse.data;
          console.log('[MyPage] 프로모션 API 전체 응답:', JSON.stringify(promotionData, null, 2));
          
          // API 응답에서 활성 프로모션 데이터 찾기
          const responseData = promotionData.data || {};
          const currentPromotion = responseData.current_promotion;
          const promotionHistory = responseData.promotion_history || [];
          
          let activePromotions: any[] = [];
          
          console.log('[MyPage] current_promotion:', currentPromotion);
          console.log('[MyPage] promotion_history:', promotionHistory);
          
          // 1. 현재 활성 프로모션 추가
          if (currentPromotion?.has_promotion && !currentPromotion?.is_expired) {
            // 클라이언트에서 직접 남은 일수 계산 (오늘 포함)
            const now = new Date();
            const endDate = new Date(currentPromotion.end_date);
            const calculatedRemainingDays = Math.ceil((endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)) + 1;
            
            activePromotions.push({
              promotion_type: currentPromotion.promotion_type,
              korean_name: getPromotionTypeName(currentPromotion.promotion_type),
              remaining_days: calculatedRemainingDays > 0 ? calculatedRemainingDays : 0,
              end_date: currentPromotion.end_date || null,
              start_date: currentPromotion.start_date || null,
              lost_on_cancel: true
            });
          }
          
          // 2. promotion_history에서 복합 프로모션 확인
          if (promotionHistory.length > 0) {
            // 최신 history 항목 확인 (배열의 첫 번째가 최신인 것 같음)
            const latestHistory = promotionHistory[0];
            const details = latestHistory?.details;
            
            console.log('[MyPage] 최신 프로모션 히스토리:', latestHistory);
            console.log('[MyPage] 프로모션 세부정보:', details);
            
            // 복합 프로모션이고 아직 진행중인 경우
            if (details?.is_compound_promotion) {
              console.log('[MyPage] 복합 프로모션 발견!');
              
              // 현재 날짜와 종료일 비교
              const now = new Date();
              const endDate = new Date(details.end_date);
              const totalRemainingDays = Math.ceil((endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)) + 1;
              
              console.log('[MyPage] 복합 프로모션 전체 종료일:', details.end_date);
              console.log('[MyPage] 복합 프로모션 총 남은 일수:', totalRemainingDays);
              
              // 복합 프로모션이 아직 유효한 경우, 다음 단계 프로모션도 추가
              if (totalRemainingDays > 0 && details.promotion_type === 'first_subscription_2weeks') {
                // trial_3days가 끝나면 자동으로 first_subscription_2weeks가 시작됨
                const trialEndDate = new Date(details.trial_end_date);
                const subscriptionStartDays = Math.ceil((endDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)) + 1;
                
                console.log('[MyPage] 첫 구독 2주 무료 남은 일수:', subscriptionStartDays);
                
                activePromotions.push({
                  promotion_type: 'first_subscription_2weeks',
                  korean_name: getPromotionTypeName('first_subscription_2weeks'),
                  remaining_days: subscriptionStartDays,
                  end_date: details.end_date,
                  start_date: details.trial_end_date, // trial 종료일이 subscription 시작일
                  lost_on_cancel: true
                });
              }
            }
          }
          
          console.log('[MyPage] 찾은 모든 활성 프로모션:', activePromotions);
          
          if (activePromotions.length > 0) {
            // 가장 남은 기간이 긴 프로모션을 primary로 설정
            const primaryPromotion = activePromotions.reduce((prev, current) => 
              (current.remaining_days > prev.remaining_days) ? current : prev
            );
            
            console.log('[MyPage] Primary 프로모션:', primaryPromotion);
            console.log('[MyPage] 총 활성 프로모션 개수:', activePromotions.length);
            
            setPromotionInfo(prev => ({
              ...prev,
              has_promotion: true,
              promotion_type: primaryPromotion.promotion_type,
              remaining_days: primaryPromotion.remaining_days,
              is_expired: false,
              promotion_at_risk: null,
              all_active_promotions: activePromotions
            }));
          } else {
            console.log('[MyPage] 활성 프로모션 없음');
            setPromotionInfo(prev => ({
              ...prev,
              has_promotion: false,
              promotion_type: null,
              remaining_days: 0,
              is_expired: false,
              promotion_at_risk: null,
              all_active_promotions: []
            }));
          }
        } else {
          console.log('[MyPage] 프로모션 API 호출 실패 또는 데이터 없음');
          setPromotionInfo(prev => ({
            ...prev,
            has_promotion: false,
            promotion_type: null,
            remaining_days: 0,
            promotion_at_risk: null,
            all_active_promotions: []
          }));
        }
      } else {
        setSubscriptionInfo({ isActive: false, subscriptions: [] });
      }
    } catch (error) {
      console.error("구독 정보 로드 실패:", error);
      setSubscriptionInfo({ isActive: false, subscriptions: [] });
    }
  };




  // 개별 구독 상세보기 함수
  const handleSubscriptionDetailClick = (subscription: SingleSubscriptionInfo) => {
    setSelectedSubscription(subscription);
    setDetailModalVisible(true);
  };

  // 상세보기 모달 닫기
  const handleDetailModalClose = () => {
    setDetailModalVisible(false);
    setSelectedSubscription(null);
  };

  // 개별 패키지 해지 함수
  const handleIndividualCancel = async (productId: number, reason?: string, detail?: string) => {
    const subscription = subscriptionInfo.subscriptions.find(s => s.productId === productId);
    if (!subscription) return;

    try {
      // 개별 패키지 해지 API 호출
      const cancelRes = await dupLogin.checkDupLogin(() =>
        api.postSubscriptionCancelAsync({
          product_id: productId,
          cancellation_reason: reason || 'other',
          cancellation_detail: detail || `개별 패키지 해지: ${subscription.productName}`
        })
      );

      if (cancelRes?.status === 200 && (cancelRes.data?.code === 1 || cancelRes.data?.success)) {
        alert.showAlert(`"${subscription.productName}" 패키지 해지가 완료되었습니다.`, () => {
          loadSubscriptionInfo(); // 구독 정보 새로고침
        });
      } else {
        alert.showAlert(
          "패키지 해지에 실패했습니다.\n" +
            (cancelRes?.data?.message || cancelRes?.message || "")
        );
      }
    } catch (error) {
      console.error("패키지 해지 오류:", error);
      alert.showAlert("패키지 해지 중 오류가 발생했습니다.");
    }
  };

  // 프로모션 타입에 따른 한글 이름 반환
  const getPromotionTypeName = (type: string | null) => {
    switch (type) {
      case 'trial_3days':
        return '3일 무료체험';
      case 'first_subscription_2weeks':
        return '첫 구독 2주 무료';
      default:
        return '프로모션';
    }
  };

  // 날짜 포맷팅 함수
  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR');
  };

  // 다음 결제일 계산 함수
  const formatNextPaymentDate = (startDate: string | undefined, isYearly: boolean) => {
    if (!startDate) return '-';
    
    try {
      const start = new Date(startDate);
      if (isNaN(start.getTime())) return '-';
      
      const nextPayment = new Date(start);
      if (isYearly) {
        nextPayment.setFullYear(nextPayment.getFullYear() + 1);
      } else {
        nextPayment.setMonth(nextPayment.getMonth() + 1);
      }
      
      return nextPayment.toLocaleDateString('ko-KR');
    } catch (error) {
      console.error('다음 결제일 계산 오류:', error);
      return '-';
    }
  };


  return (
    <section className="content">
      <div className="round-box">
        <div className="list-style-one">
          <ul className="list-group">
            <li className="list-group-item">
              <div className="title" style={{ fontSize: 14 }}>
                이메일
              </div>
              <div className="body">{email || ""}</div>
            </li>
            <li className="list-group-item">
              <div className="title" style={{ fontSize: 14 }}>
                연락처
              </div>
              <div className="body">{phone || ""}</div>
            </li>
            <li className="list-group-item">
              <div className="title" style={{ fontSize: 14 }}>
                주소
              </div>
              <div className="body">{address || ""}</div>
            </li>
          </ul>
        </div>
      </div>
      <button
        onClick={clearUserInfo}
        type="button"
        className="btn text-gray-300 sm-view m-right "
      >
        로그아웃
      </button>
      <button type="button" className="btn text-gray-300 sm-view m-right ">
        <Link to={pages.withdrawal} className="text-gray-200">
          회원탈퇴
        </Link>
      </button>


      <div className="d-flex justify-content-between align-items-center mt-8 mb-4">
        <h4 className="text-dark mb-0">사용중인 이용권</h4>
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => {
              history.push(pages.payment);
            }}
          >
            추가 구매하기
          </button>
          {!subscriptionInfo.isActive && !(promotionInfo.all_active_promotions && promotionInfo.all_active_promotions.length > 0) && (
            <button
              type="button"
              className="btn btn-sm btn-success"
              onClick={() => history.push(pages.subscription)}
            >
              구독 시작하기
            </button>
          )}
        </div>
      </div>

      {/* 이용중인 구독 서비스 섹션 */}
      {((subscriptionInfo.isActive && subscriptionInfo.subscriptions.length > 0) ||
        (promotionInfo.all_active_promotions && promotionInfo.all_active_promotions.length > 0)) && (
        <div className="mb-5">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0 text-dark">
              이용중인 구독 서비스 ({subscriptionInfo.subscriptions.length + (promotionInfo.all_active_promotions?.length || 0)}개)
            </h5>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={() => history.push(pages.mypage + "/subscription")}
            >
              구독 관리
            </button>
          </div>
          
          <div className="row g-3">
            {/* 모든 활성 프로모션 아이템들 */}
            {promotionInfo.all_active_promotions && promotionInfo.all_active_promotions.map((promo, index) => (
              <div key={`promo-${index}`} className="col-md-4">
                <div className="card h-100 shadow-sm border-warning">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-3">
                      <div 
                        className="me-3 d-flex align-items-center justify-content-center bg-warning text-white"
                        style={{ width: '48px', height: '48px', borderRadius: '8px', fontSize: '24px' }}
                      >
                        🎁
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="card-title mb-1">{promo.korean_name || getPromotionTypeName(promo.promotion_type)}</h6>
                        <span className="badge bg-warning text-dark">프로모션 중</span>
                      </div>
                    </div>
                    
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <small className="text-muted">이용 금액</small>
                        <span className="text-warning fw-bold">
                          무료
                        </span>
                      </div>
                      
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <small className="text-muted">남은 기간</small>
                        <small className="text-dark">
                          <strong>{promo.remaining_days}일</strong>
                        </small>
                      </div>
                      
                      <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted">만료일</small>
                        <small className="text-dark">
                          {promo.end_date ? formatDate(promo.end_date) : '-'}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {/* 구독 패키지 아이템들 */}
            {subscriptionInfo.subscriptions.map((subscription) => (
              <div key={subscription.productId} className="col-md-4">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <div className="d-flex align-items-center mb-3">
                      <img 
                        src="https://sulfac-image.s3.ap-northeast-2.amazonaws.com/None_1721128376471805.png" 
                        alt="구독" 
                        className="me-3"
                        style={{ width: '48px', height: '48px', borderRadius: '8px' }}
                      />
                      <div className="flex-grow-1">
                        <h6 className="card-title mb-1">{subscription.productName}</h6>
                        {isSubscriptionExpired(subscription) ? (
                          <span className="badge bg-secondary">만료됨</span>
                        ) : subscription.cancel_requested ? (
                          <span className="badge bg-warning text-dark">종료 예정</span>
                        ) : (
                          <span className="badge bg-success">구독 중</span>
                        )}
                      </div>
                    </div>
                    
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <small className="text-muted">결제 금액</small>
                        <span className="text-primary fw-bold">
                          {util.addComma(subscription.amount)}원
                          <small className="text-muted ms-1">/ {subscription.periodText}</small>
                        </span>
                      </div>
                      
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <small className="text-muted">
                          {isSubscriptionExpired(subscription)
                            ? '만료일'
                            : subscription.cancel_requested
                              ? '서비스 종료일'
                              : '다음 결제일'}
                        </small>
                        <small className="text-dark">
                          {(isSubscriptionExpired(subscription) || subscription.cancel_requested) && subscription.expiry_date
                            ? formatDate(subscription.expiry_date)
                            : subscription.nextPaymentDate
                              ? formatDate(subscription.nextPaymentDate)
                              : formatNextPaymentDate(subscription.startDate, subscription.isYearly)}
                        </small>
                      </div>
                      
                      <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted">구독 시작일</small>
                        <small className="text-dark">{formatDate(subscription.startDate)}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
        </div>
      )}

      <div
        className="payment-list flex-wrap"
      >
        {expires
          .filter((exp) => exp.expiry_date)
          .map((expire, index) => {
            return (
              <div className="payment-list-item bg-white mb-5" key={index}>
                <div className="img-wrap">
                  <img src={expire.permission_image} alt={expire.permission_title} />
                </div>
                <div className="flex-2">
                  <div className="title-lg">{expire.permission_title}</div>
                  <div className="list-style-sm">
                    <ul className="list-group">
                      <li className="list-group-item">
                        <div className="title pe-3">이용기간</div>
                        <div className="body">
                          {expire?.expiry_date?.format("yyyy.MM.dd")}
                        </div>
                      </li>
                      <li className="list-group-item">
                        <div className="title pe-3">잔여일수</div>
                        <div className="body">
                          <span className="text-danger">
                            {getRemainDays(expire)}
                          </span>
                          일
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
      </div>

      {/* 구독 상세보기 모달 */}
      <SubscriptionDetailModal
        visible={detailModalVisible}
        subscription={selectedSubscription}
        onClose={handleDetailModalClose}
        onCancel={handleIndividualCancel}
        cardInfo={subscriptionInfo.cardInfo}
        hasPromotion={!!(promotionInfo.promotion_at_risk || promotionInfo.all_active_promotions?.length)}  // 🎁 모든 활성 프로모션 확인
        promotionInfo={promotionInfo.promotion_at_risk ? {
          promotion_type: promotionInfo.promotion_at_risk.promotion_type,
          remaining_days: promotionInfo.promotion_at_risk.remaining_days
        } : undefined}  // 🎁 손실 위험 프로모션 정보만 전달
        allActivePromotions={promotionInfo.all_active_promotions || []}  // 🎁 모든 활성 프로모션 정보 전달
      />

    </section>
  );
};
